import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { ParamContext } from '../../service/param.context';
import { SERVER_API_URL } from '../../../app.constants';
import { Observable } from 'rxjs';
import { AdvanceStudyRequest } from '../model/advance-study-request.model';
import { AdvanceSamplesRequest } from '../model/advance-sample-request.model';
import { AdvancedGermplasmPreview } from '../model/advanced-germplasm-preview';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';

@Injectable()
export class AdvanceService {

    constructor(
        private http: HttpClient,
        private context: ParamContext
    ) {
    }

    advanceStudy(studyId: number, request: AdvanceStudyRequest): Observable<number[]> {
        const url = SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/advance`;
        return this.http.post<number[]>(url, request, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    advanceStudyPreview(studyId: number, request: AdvanceStudyRequest): Observable<AdvancedGermplasmPreview[]> {
        const url = SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/advance/preview`;
        return this.http.post<AdvancedGermplasmPreview[]>(url, request);
    }

    advanceSamples(studyId: number, request: AdvanceSamplesRequest): Observable<number[]> {
        const url = SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/advance/samples`;
        return this.http.post<number[]>(url, request, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    advanceSamplesPreview(studyId: number, request: AdvanceSamplesRequest): Observable<AdvancedGermplasmPreview[]> {
        const url = SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/advance/samples/preview`;
        return this.http.post<AdvancedGermplasmPreview[]>(url, request);
    }

    getPreviewAdvanceCrossValues(studyId: number, gids: number[]): Observable<Map<number, string>>  {
        const url = SERVER_API_URL + `crops/${this.context.cropName}/programs/${this.context.programUUID}/studies/${studyId}/advance/preview/cross-values`;
        const params = { gids };
        return this.http.get<Map<number, string>>(url, { params, context: new HttpContext().set(EnableLoadingIndicator, true) });
    }
}
